import {ApplicationsFilter} from "@/models";

export default {
  namespaced: true,

  state: {
    applicationsFilter: new ApplicationsFilter()
  },

  mutations: {
    setApplicationsFilter(state, payload) {
      state.applicationsFilter = payload
    }
  }
}
